export const LeftArrowAltIcon = ({ color = '#6B7A86' }: { color?: string }): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 7.77271H1" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.77273 12.5455L1 7.77273L5.77273 3" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
